export const types = {

    SELECT_PAGE: 'SELECT_PAGE',
}